import { every } from 'lodash';

export const traceSpanMetricFilter = (span, spanFiltersGetter) => {
    if (!span?.name || !span?.attributes) {
        return false;
    }
    const spanFilters = spanFiltersGetter();
    if (!spanFilters) {
        return true;
    }
    const { name, attributes } = span || {};
    const filtersConfig = spanFilters[name];

    if (filtersConfig) {
        return every(filtersConfig, (allowedValues, key) => {
            const allowValue = allowedValues?.has(attributes[key]);
            return allowValue;
        });
    }
    return false;
};
